import { useSelector } from "react-redux";
import { selectMetaTimesData } from "../redux/reducers/metaTimes.reducer";
import {
  SelectFilters,
  SelectInitialStateFilters,
} from "../redux/reducers/timesConfirmationReport.reducer";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { useTimesMetadata } from "./useTimesMetadata";

export const useTimesConfirmationReport = () => {
  useTimesMetadata();
  const MetaTimesInfo = useSelector(selectMetaTimesData);
  const filters = useSelector(SelectFilters);
  const initialStatefilters = useSelector(SelectInitialStateFilters);
  const { userRolesList } = useSelector(selectUserRoles);

  return {
    MetaTimesInfo,
    filters,
    initialStatefilters,
    userRolesList,
  };
};
